import { useMemo } from "react";
import { convertTimeRangeToHours } from "fe-common/range/rangeConvertor";
import {
  ConversationNextQuestionSuggestions,
  QualifiedFeatureFragment,
} from "fe-common/graphql";

export interface useRangeQuestionElementsApi {
  isAnswered: boolean;
  abstractSuggestion: QualifiedFeatureFragment;
  rangeItems: QualifiedFeatureFragment[];
  suggestion: QualifiedFeatureFragment;
}

export enum RefinementRangeSortType {
  Ascending,
  Descending,
}

export const useRangeRefinements = ({
  suggestion,
  sortType = RefinementRangeSortType.Ascending,
}: {
  suggestion?: ConversationNextQuestionSuggestions;
  sortType?: RefinementRangeSortType;
}) => {
  const abstractSuggestion = useMemo(() => suggestion.suggestion, [suggestion]);

  const rangeItems = useMemo(
    () =>
      suggestion.refinements
        .flatMap((r) => r.qualifiers)
        // Sort ascending
        .sort(
          (a, b) =>
            (sortType === RefinementRangeSortType.Descending ? -1 : 1) *
              convertTimeRangeToHours(a.range || a.value.range) +
            (sortType === RefinementRangeSortType.Ascending ? -1 : 1) *
              convertTimeRangeToHours(b.range || b.value.range),
        ),
    [suggestion, sortType],
  );

  const relation = useMemo(() => abstractSuggestion.qualifiers[0]?.relation, [
    abstractSuggestion,
  ]);

  return {
    abstractSuggestion,
    rangeItems,
    relation,
    suggestion,
  };
};
